import { Card, CardContent, CardHeader, Grid, Typography } from "@mui/material";
import "./MUICard.style.css";

// Card Header
const MUICardHeader = ({ title, action }) => {
  <CardHeader
    className="mui-card-header"
    title={
      <Typography fontWeight={"bold"} variant="button">
        {title}
      </Typography>
    }
    action={action}
  />;
};


// Main Card
const MainCard = ({
  children,
  padding,
  removeDefaultPadding,
  title,
  className,
  removeBorder,
  style,
  action,
}) => {
  const paddingBottom = padding ? padding * 8 : removeDefaultPadding ? 0 : 16;

  return (
    <Card
      style={style}
      className={`${className}`}
      variant="outlined"
      sx={{ borderRadius: 2, border: removeBorder ? "none" : "" }}
    >
      {title ? <MUICardHeader title={title} action={action} /> : null}
      <CardContent sx={{ padding }} style={{ paddingBottom }}>
        {children}
      </CardContent>
    </Card>
  );
};


// MUI Card Header
const SilentHeader = ({
  children,
  padding,
  title,
  removeDefaultPadding,
  action,
}) => (
  <MainCard padding={0} removeDefaultPadding>
    <MainCard
      style={{
        borderRadius: 0,
      }}
      removeBorder
    >
      <Grid container>
        <Grid size={{sm: 8}}>
          <Typography
            variant="caption"
            textTransform={"uppercase"}
            fontWeight={"bold"}
          >
            {title}
          </Typography>
        </Grid>
        <Grid size={{sm: 4}} style={{ textAlign: "right" }}>
          {action}
        </Grid>
      </Grid>
    </MainCard>

    <MainCard
      style={{
        borderRadius: 0,
      }}
      removeBorder
      padding={padding}
      removeDefaultPadding={removeDefaultPadding}
    >
      {children}
    </MainCard>
  </MainCard>
);


// Actual MUI Card
const MUICard = ({
  children,
  padding,
  removeDefaultPadding,
  title,
  className,
  removeBorder,
  style,
  action,
  silentHeader,
}) => {
  const mainCardProps = {
    children,
    padding,
    removeDefaultPadding,
    title,
    className,
    removeBorder,
    style,
    action,
  };

  return silentHeader ? (
    <SilentHeader {...mainCardProps} />
  ) : (
    <MainCard {...mainCardProps} />
  );
};


export default MUICard;